import { SubMenuListContainer } from '@model-framework/menu';
import { ZoneShapeMainMenu } from './ZoneShapeMainMenu';
import type { StickyZoneShape } from '../../../domain';
import { ZoneShapeSubMenu } from './ZoneShapeSubMenu';

type Props = {
  currentShape?: StickyZoneShape; // 複数選択時など現在の値が一意に決まらないケースがある
  menuSize: number;
  items: Readonly<StickyZoneShape[]>;
  isOpen: boolean;
  onMenuClicked(): void;
  onSelected(newShape: StickyZoneShape): void;
  text: string;
};

export const ZoneShapeMenu: React.FC<Props> = ({
  currentShape,
  menuSize,
  items,
  isOpen,
  onMenuClicked,
  onSelected,
  text,
}: Props) => {
  const size = {
    width: menuSize * items.length,
    height: menuSize,
  };

  return (
    <g>
      <ZoneShapeMainMenu isSelected={isOpen} menuSize={menuSize} onClick={onMenuClicked} text={text} />
      {isOpen && (
        <SubMenuListContainer menuSize={menuSize} rectSize={size}>
          {items.map((zoneShape, i) => {
            return (
              <g key={zoneShape} transform={`translate(${menuSize * i}, 0)`}>
                <ZoneShapeSubMenu
                  zoneShape={zoneShape}
                  menuSize={menuSize}
                  isSelected={currentShape === zoneShape}
                  onClick={() => onSelected(zoneShape)}
                />
              </g>
            );
          })}
        </SubMenuListContainer>
      )}
    </g>
  );
};
